/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: MyLabelPRCNameFactory.ts
 * Project: mle-client-n
 * Committed last: 2022/11/25 @ 1114
 * ---
 * Description:
 */

import {AbstractPrecompiledNameFactory} from "../abstract/AbstractPrecompiledNameFactory";
import {MyLabelPrecompiledFieldInput} from "./MyLabelPrecompiledFieldFactory";
import {DataRefNameFactory} from "@revodigital/mpes/lib/components/data/DataRefNameFactory";

/**
 * Factory per calcolare il nome di un precompilato sulla base dei suoi dati
 */
export class MyLabelPRCNameFactory extends AbstractPrecompiledNameFactory<MyLabelPrecompiledFieldInput> {
    private _dataRefFactory = new DataRefNameFactory();

    calculateName(data: MyLabelPrecompiledFieldInput): string {
        return `${this._dataRefFactory.extractName(data.fieldName)}_${data.shapeType.toLowerCase()}`
    }
}